import useUser from 'hooks/useUser'

import { shouldDoRedirect } from './DealerRedirector'

// This was duplicated inline in NavbarContainer and Footer, where the copies
// drifted when shouldDoRedirect's signature changed.
//
// Keep this in its own module. Brand builds rewrite the './DealerRedirector'
// import to the brand variant; moving this hook into DealerRedirector.tsx would
// bind it to the base predicate instead and silently re-hide the chrome.
export function useShouldHideForRedirect(): boolean {
    const { user, isLoggedIn } = useUser()

    if (!isLoggedIn) {
        return false
    }

    const redirectExpected = shouldDoRedirect(
        user?.dealerPortalUrl,
        user?.isLender,
    )

    return redirectExpected === undefined || redirectExpected
}

export default useShouldHideForRedirect
